import { getRefresh } from "./UserLoginService";
import { store } from "../utils/redux/store";
import {
  setClearUserDetails,
  setUserDetails,
} from "../utils/redux/reducer/userSlice";

export const refreshAccessToken = async () => {
  try {
    const newdata = await getRefresh();
    if (newdata.success) {
      // Update Redux state
      store.dispatch(setUserDetails(newdata.data));
      localStorage.setItem("accessToken", newdata.data.accessToken);
      return newdata.data.accessToken; // Return the new access token
    } else {
      store.dispatch(setClearUserDetails());
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      throw new Error("Failed to refresh token");
    }
  } catch (error) {
    store.dispatch(setClearUserDetails());
    console.error("Error refreshing access token:", error);
    throw error;
  }
};
